module.exports = __webpack_public_path__ + "img/Listings_of_your_business.fd453989.png";